import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { AgenteControlService } from './agentecontrol.service';
import { VListaAgentesControlItemViewModel, FilterSearchingRegAgenteControlViewModel, UsuarioViewModel } from '../../usuarios/usuarios.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { RegAgenteControlViewModel } from './agentecontrol.types';
import { UsuariosService } from '../../usuarios/usuarios.service';

@Component({
    selector: 'app-agentecontrol-list',
    templateUrl: './agentecontrol-list.component.html',
})
export class AgenteControlListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultAgentesControl: VListaAgentesControlItemViewModel;
    listComunidadesAutonomas: Tc[];
    cols: any[];
    visibilitySpinner = false;
    public isCollapsed = false;
    habilitarNuevo = false;
    EsComunidadAutonoma = false;
    usuarioTecnicoAC: UsuarioViewModel;
    model?: FilterSearchingRegAgenteControlViewModel;

    private CaAutorizadaUsuario: number;
    CaAutorizadaUsuarioDescripcion: string | undefined;

    exportIsAvailable: boolean = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private agenteControlService: AgenteControlService,
        private usuariosService: UsuariosService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultAgentesControl = new VListaAgentesControlItemViewModel();
    }

    ngOnInit() {
        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidadesAutonomas = res;
            this.CaAutorizadaUsuarioDescripcion = res.at(0)?.Descripcion;
        });

        this.EsComunidadAutonoma = this.isCA;
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'IdUsuario', header: 'Idusuario', display: 'none' },
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Apellidos', header: 'Apellidos' },
            { field: 'Nif', header: 'NIF/NIE' },
            { field: 'Ropo', header: 'ROPO' },
            { field: 'DescripcionCa', header: 'Comunidad Autónoma autorizada' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'Localidad', header: 'Localidad' },
            { field: 'CodigoPostal', header: 'CP' },
            { field: 'Telefono', header: 'Teléfono' },
            { field: 'Email', header: 'Email' },
            { field: 'Activo', header: 'Activo' },
            { field: 'FechaBaja', header: 'FechaBaja', display: 'none' },
        ];

        this.form = this.fb.group({
            Nombre: '',
            Apellidos: '',
            Nif: ['', CustomValidator.NIFValidator],
            Ropo: '',
            IdCa: null,
            Telefono: '',
            Activo: EnumSiNoTodos.TODOS,
            Email: '',
        });

        if (this.isCA) {
            this.usuariosService.getUsuarioCaById(this.loggedInUser!.Id).subscribe(res => {
                this.CaAutorizadaUsuario = res.IdCa;
            });

            this.form.patchValue({
                IdCa: this.CaAutorizadaUsuario,
                Activo: EnumSiNoTodos.SI,
            });
        }

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.habilitarNuevo = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_AGENTE_CONTROL).Visible;

        this.loadBack();
    }

    loadBack() {
        if (
            this.agenteControlService.currentFilter.Nombre != '' ||
            this.agenteControlService.currentFilter.Apellidos != '' ||
            this.agenteControlService.currentFilter.Nif != '' ||
            this.agenteControlService.currentFilter.Ropo != '' ||
            this.agenteControlService.currentFilter.IdCa != null ||
            this.agenteControlService.currentFilter.Activo != EnumSiNoTodos.TODOS ||
            this.agenteControlService.currentFilter.Telefono != '' ||
            this.agenteControlService.currentFilter.Email != ''
        ) {
            this.form.patchValue({
                Nombre: this.agenteControlService.currentFilter.Telefono,
                Apellidos: this.agenteControlService.currentFilter.Apellidos,
                Nif: this.agenteControlService.currentFilter.Nif,
                Ropo: this.agenteControlService.currentFilter.Ropo,
                IdCa: this.agenteControlService.currentFilter.IdCa,
                Telefono: this.agenteControlService.currentFilter.Telefono,
                Activo: this.agenteControlService.currentFilter.Activo,
                Email: this.agenteControlService.currentFilter.Email,
            });

            if (this.isCA) {
                this.form.patchValue({
                    IdCa: this.CaAutorizadaUsuario,
                    Activo: EnumSiNoTodos.SI,
                });
            }

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.agenteControlService.currentFilter.Nombre = this.form.value.Nombre;
        this.agenteControlService.currentFilter.Apellidos = this.form.value.Apellidos;
        this.agenteControlService.currentFilter.Nif = this.form.value.Nif;
        this.agenteControlService.currentFilter.Ropo = this.form.value.Ropo;

        if (this.isCA) {
            this.agenteControlService.currentFilter.IdCa = this.CaAutorizadaUsuario;
            this.agenteControlService.currentFilter.Activo = EnumSiNoTodos.SI;
        } else {
            this.agenteControlService.currentFilter.IdCa = this.form.value.IdCa;
            this.agenteControlService.currentFilter.Activo = this.form.value.Activo;
        }

        this.agenteControlService.currentFilter.Telefono = this.form.value.Telefono;
        this.agenteControlService.currentFilter.Email = this.form.value.Email;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = 'Apellidos') {
        this.loading = true;

        let model: FilterSearchingRegAgenteControlViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        this.agenteControlService.postGetPagedByFilter(model).subscribe(res => {
            this.resultAgentesControl = res;
            this.loading = false;

            this.exportIsAvailable = res?.ResultList ? res?.ResultList?.length > 0 : false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Nombre: '',
            Apellidos: '',
            Nif: '',
            Ropo: '',
            IdCa: null,
            Telefono: '',
            Email: '',
            Activo: EnumSiNoTodos.TODOS,
        });

        if (this.isCA) {
            this.form.patchValue({
                Activo: EnumSiNoTodos.SI,
            });
        }

        this.searchingButton = false;
        this.isCollapsed = false;
        this.exportIsAvailable = false;

        this.resultAgentesControl = new VListaAgentesControlItemViewModel();
    }

    CreateModel() {
        this.model = new FilterSearchingRegAgenteControlViewModel();

        Object.assign(this.model, this.form.value);

        this.model.EsComunidadAutonoma = this.isCA;
        this.model.IdUsuario = this.loggedInUser!.Id;
        if (this.isCA) {
            this.model.IdCa = this.CaAutorizadaUsuario;
        }

        return this.model;
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/registros/agentescontrol/create']);
    }

    onEdit(item: VListaAgentesControlItemViewModel) {
        this.router.navigate(['/mantenimiento/registros/agentescontrol/edit', item.IdUsuario]);
    }

    //onDelete(item: VListaAgentesControlItemViewModel) {

    //    this.confirmationService.confirm({
    //        message: '¿Está seguro?',
    //        accept: () => {
    //            //Actual logic to perform a confirmation
    //            this.agenteControlService.deleteAgenteControl(item.IdUsuario)
    //                .subscribe(res => {
    //                    this.addSuccessMessage("Agente de control dado de baja correctamente");
    //                    this.onSearchButton();
    //                },
    //                    error => this.addErrorMessage("Error al dar de baja el Agente de Control."));
    //        }
    //    });

    //}

    onDeleteTecnicoExistenteComoACyEA(item: RegAgenteControlViewModel) {
        this.agenteControlService.getAgenteControl(item.IdUsuario).subscribe(result => {
            this.usuarioTecnicoAC = result;
        });

        this.confirmationService.confirm({
            message: '¿Está seguro de que quiere borrar el usuario Agente de Control?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.agenteControlService.deleteTecnicoExistenteComoACyEA(this.usuarioTecnicoAC).subscribe({
                    next: () => {
                        this.addSuccessMessage('Usuario Agente de Control borrado correctamente.');
                        this.onSearchButton();
                    },
                    error: () => this.addErrorMessage('Error al borrar el usuario Agente de Control.'),
                });
            },
        });
    }

    onReactivateTecnicoExistenteComoACyEA(item: RegAgenteControlViewModel) {
        this.agenteControlService.getAgenteControl(item.IdUsuario).subscribe(result => {
            this.usuarioTecnicoAC = result;
        });
        this.confirmationService.confirm({
            message: '¿Está seguro de que quiere reactivar el usuario Agente de Control?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.agenteControlService.reactivateTecnicoExistenteComoACyEA(this.usuarioTecnicoAC).subscribe({
                    next: () => {
                        this.addSuccessMessage('Usuario Agente de Control reactivado correctamente.');
                        this.onSearchButton();
                    },
                    error: () => this.addErrorMessage('Error al reactivar el usuario Agente de Control.'),
                });
            },
        });
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.agenteControlService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
